module.exports = __webpack_public_path__ + "static/media/searchforself.07b2e483.jpg";